
<template>
  <div class="authOption">
    <crumbs>
      <i class="icon-stack2"></i>
      <span class="text">{{(actionType == "reg")?registerLan.crumbs.newaAccount:registerLan.crumbs.amend}}</span>
    </crumbs>
    <div class="content_box">
      <h2>{{registerLan.sales.title}}</h2>
      <div class="inputBox">
        <auth-list :auth_list="auth_data" ref="tree" :lang="lang_data"></auth-list>
        <el-button @click="setCheckedNodes" v-if="!selectBool">{{registerLan.selectBtn}}</el-button>
        <el-button @click="setCheckedNodes" v-else>{{registerLan.emptyBtn}}</el-button>
        <el-button @click="resetData">{{registerLan.resetBtn}}</el-button>
      </div>
      <span class="input-group-btn">
        <button class="btn bg-teal" type="submit" @click="submitFn">{{registerLan.changeBtn}}</button>
      </span>
    </div>
    <Modal v-model="modalShow" class="modal-content-j" size="sm" :header="false" :footer="false" :backdrop="!modalLink" @hide="toModalLink">
      <div :class="(modalBool?'color-green':'color-red')">
        <i class="glyphicon" :class="(modalBool?'glyphicon-ok':'glyphicon-warning-sign')"></i>
          <span>{{modalBool?registerLan.submitResult.succeed:registerLan.submitResult.err}}</span>
      </div>
      <div v-show="modalLink" @click="modalShow=false" class="btn btn-success btn-xs">{{registerLan.logOut.yes}}</div>
    </Modal>
  </div>
</template>
<script>
import crumbs from 'components/crumbs'
import mimput from 'components/mimput'
import  {URL_SAVEPRIVILEGE } from '../api/api.js'
import sidebarListLink from './../MultiLanguage/menuAllList'
import authList from "components/authList"

export default {
  name: "authOption",
  mixins: [
    require("common/mixin/base.js").base({registerLan:"authOption"}),
    require("common/mixin/base.js").base({sidebarLan:"sidebarList"}),
    require("common/mixin/validate.js").validate(),
    require("common/mixin/modal.js").modal()
  ],
  data() {
    return {
      actionType: (this.$route.query.id || this.$route.query.id == 0)?"change":"reg",
      selectBool:false,
      sidebarListLink: sidebarListLink
    }
  },
  computed: {
    auth_data() {
      let _auth_list = [];
      this.$route.query.data.forEach(item => {
        _auth_list.push({
          right_id: item.split("$")[0],
          entity: item.split("$")[1].split("/")
        });
      });
      return _auth_list;
    },
    lang_data() {
      let _lang_data = [];
      for(var key in this.sidebarListLink){
        if(this.sidebarLan[key].text) {
          _lang_data.push({
            right_id: this.sidebarListLink[key].Role_ID,
            text: this.sidebarLan[key].text
          })
        } else {
          console.log("请在文件中配置该菜单");
        }
      }
      return _lang_data;
    }
  },
  methods:{
    setCheckedNodes() {
      //全选
      if(!this.selectBool){
          this.$refs.tree.Check_All();
          this.selectBool=true;
      }else{
          this.$refs.tree.Clear_All();//清空
          this.selectBool=false;
      }
    },
    submitFn(){
      let _data = this.$refs.tree.Get_Data();
      //TODO
      this.$http.post(URL_SAVEPRIVILEGE, {"role": this.$route.query.Role_ID,"prioritys":_data}).then(res => {
        if(res.data.code == '200'){
           this.modalLink = "/authList";
           this.modalBool = true;
           _data.forEach(item => {
             item.entity = item.entity.join("/");
           });
           sessionStorage.rightObject = JSON.stringify(_data);
           // TODO menulList 逐渐废弃使用
           // 以下代码段，逐渐废弃
           // BEGIN
           let _right_list = [];
           _data.forEach(item => {
             _right_list.push(item.right_id);
           });
           sessionStorage.menuList = JSON.stringify(_right_list);
           // END
          // 如果Role_ID和当前用户的purview相同，那么进行初始化，否则不进行
          if (JSON.parse(sessionStorage.user).purview == this.$route.query.Role_ID) {
            this.SIDEBARVUE.Init_SideBar();
          }
        }else if(res.data.code == '0'){
          this.user_id_point = true;
        }
        this.modalShow = true
      })
    },
    selectChange(key) {
      this[key] = event.target.value
    },
    resetData() {
      this.$refs.tree.Reset_Data();
    }
 },
  components: {
    crumbs,
    mimput,
    authList
  }
}
</script>

<style lang='scss' type="text/scss" scoped>
.content_box {
  position: relative;
  margin: 0 20px 20px;
  padding: 20px 20px;
  border: 1px solid #ddd;
  background: #fff;
  h2 {
    line-height: 55px;
    margin-top: 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 24px;
    font-weight: 700;
  }
  .inputBox {
    overflow: hidden;
    .form-group {
      position: relative;
      height: 36px;
      margin-bottom: 40px;
      label {
        line-height: 40px;
        position: absolute;
        padding: 0;
        color: #000;
      }
      .inputbox {
        margin-left: 110px;
        position:relative;
        input[type='file'] {
          border: none;
          position: relative;
          z-index:99;
        }
        .date{
          position: absolute;
          right: 10px;
          top:0;
        }

        .row {
          position: relative;
          span.help-block {
            position: absolute;
            top:30px;
            &.passwordTip{
              top:-2px;;
              left:20px;
              z-index:0;
            }
          }
          span.file-help-block {
            position: absolute;
            top: 39px;
          }
          label.file-uploads {
            background: #eee;
            padding-left: 10px;
            padding-right: 10px;
            cursor: pointer;
            &:hover {
              background: #ccc;
            }
          }
          .fileName {
            position: absolute;
            min-width: 100px;
            max-width: 100px;
            height: 50px;
            top: -5px;
            left: 150px;
          }
        }
      }
    }
  }
  &:nth-of-type(3) {
    margin-bottom: 76px;
  }
  .input-group-btn {
    width: 100%;
    display: flex;
    button.btn {
      border-radius: 5px;
      position: absolute;
      top: 40px;
      left: 50%;
      padding: 7px 20px;
      transform: translateX(-50%);
      cursor: pointer;
      margin-bottom:20px;
    }
  }
}

.false {
  color: #f44336;
  font-size: 12px;
  &:before {
    position: relative;
    top: 1px;
    margin-right: 5px;
  }
}

.bg {
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
    align-items: center; // display: none;
    z-index: 10000;
    .tips {
      padding: 17px;
      width: 33.3%;
      background-color: #fff;
      text-align: center;
      border-radius: 5px;
      animation: show 0.3s;
      min-width: 100px;
      @keyframes show {
        0% {
          transform: scale(0.7);
          -webkit-transform: scale(0.7);
        }
        45% {
          transform: scale(1.05);
          -webkit-transform: scale(1.05);
        }
        80% {
          transform: scale(0.95);
          -webkit-transform: scale(0.95);
        }
        100% {
          transform: scale(1);
          -webkit-transform: scale(1);
        }
      }
      p {
        margin-top: 25px;
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: 300;
        color: #797979;
      }
      button {
        padding: 10px 32px;
        margin-top: 26px;
        border-radius: 5px;
        background-color: rgb(140, 212, 245);
        font-size: 17px;
        font-weight: 500;
        cursor: pointer;
        color: #fff;
        border: none;
        outline: none;
        &:hover {
          background: rgb(134, 204, 235);
        }
      }
    }
  }
  </style>



// WEBPACK FOOTER //
// authOption.vue?338d03ab